<template>
  <transition name="modal">
    <div class="modal__mask">
      <div class="modal__wrapper">

        <section class="modal__body">
          <div class="modal__container">
            <h2 class="modal__title_auth">Планирование и размещение баннеров</h2>

            <el-form ref="formAuth" :model="formAuth" >
              <el-form-item
                prop="login"
                :rules="[{ required: true, message: ' '}]">
                  <el-input placeholder="Логин" 
                            v-model="formAuth.login" 
                            class="auth__input" >
                  </el-input>
              </el-form-item>

              <el-form-item
                prop="password"
                :rules="[{ required: true, message: ' '}]">
                  <el-input placeholder="Пароль" 
                            v-model="formAuth.password" 
                            class="auth__input" 
                            show-password >
                  </el-input>
              </el-form-item>

              <el-form-item>
                <div class="modal__btn" @click="submitForm('formAuth')">Войти</div>
              </el-form-item>
            </el-form>

          </div>
        </section>
      </div>
    </div>
  </transition>
</template>

<script>
  import axios from 'axios';
  import qs from 'qs'

  export default {
  name: 'AuthModal',
  data() {
    return {
      formAuth: {
        login: '',
        password: '',
      },
      rules: {
        login: {
          required: true,
          //validator: this.customValidator,
          //trigger: 'blur'
        },
        password: {
          required: true,
          //validator: this.customValidator,
          //trigger: 'blur'
        }
      },
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {

          const request = {
              username: this.formAuth.login,
              password: this.formAuth.password
          };
          const self = this;

          axios(process.env.VUE_APP_BACKEND_HOST + '/api/auth', {
              data: qs.stringify(request),
              method: "post",
              withCredentials: true,
              headers : {'Content-Type': 'application/x-www-form-urlencoded'}
          })
            .then(function(response) {
                if (response.data.status === "success") {

                  localStorage.userId = response.data.result.user_id;
                  localStorage.firstName = response.data.result.first_name;
                  localStorage.lastName = response.data.result.last_name;
                  localStorage.username = response.data.result.login;
                  self.$router.push("/");
                  self.$emit('close');
                } else {
                  self.$refs[formName].resetFields();
                  alert("Неверный логин или пароль");
                }
            })
          ;

        }
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.modal__mask {
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;

  z-index: 5;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #F3F7F9;
  transition: opacity 0.3s ease;
}

.modal__wrapper {
  border-radius: 2px;
  transition: all 0.3s ease;
  width: 65%;
  max-width: 700px;
}

.modal__container { padding: 22px 15px; }
.modal__title_auth {
  font-weight: 600;
  font-size: 45px;
  line-height: 49px;
  margin-bottom: 30px;
  text-align: center;
  color: #034580;
}

.auth__input {
  width: 55%;
  display: block;
  margin: 15px auto;
}

.modal__btn {
  display: block;
  margin: 15px auto;
  padding: 12px 40px;
  font-size: 16px;
  line-height: 20px;
  font-weight: 700;
  color: #FFFFFF;
  border: 0;
  background: #0A467E;
  cursor: pointer;
  width: fit-content;

  &:focus { outline: none; }
}
</style>
